export default __webpack_public_path__ + "static/media/attire.d925abc5.png";